export default __webpack_public_path__ + "static/media/sendEmail.fd1eb756.svg";